import http from 'hub-http/clients/apiClient';
import NetworkBinding from 'growth-payments-core/binding/networkBinding';
import { createNetworkHook } from 'growth-payments-core/binding/useNetworkBinding';
import catchAndRethrow from '../utils/catchAndRethrow';
const TOOL_USAGE_ENDPOINT = 'commerce/analytics/v1/usage/tools?skipUserFiltering=true';
export const fetchToolUsage = () => http.get(TOOL_USAGE_ENDPOINT).catch(catchAndRethrow);
export const toolUsageBinding = new NetworkBinding(fetchToolUsage);
export const useToolUsageBinding = createNetworkHook(toolUsageBinding);